export class ControllerInfoForConfigDisplay
{
    constructor(json: any = null)
    {
        if (json)
        {
            Object.assign(this, json);
        }
    }

    ControllerId: number;
    ControllerUId: string;
    ControllerName: string;
    GatewayName: string;
    GatewayUId: string;
    Apan: number;
    CommunicationPIN: string;
    CommCardUId: string;
    SmartConnectId: number;
}
